import type { ReactNode } from 'react';

import classNames from 'classnames';

import { Icon } from '@iconik-io/uad';

import Button from '../../../ui/button/button';

import styles from './recognized_persons.module.css';

type Props = {
  children: ReactNode;
  isExpanded: boolean;
  onChange: (isExpanded: boolean) => void;
  disabled?: boolean;
};

export function ToggleSegmentButton({
  children,
  isExpanded,
  onChange,
  disabled = false,
}: Props) {
  return (
    <Button
      onClick={() => onChange(!isExpanded)}
      size="s"
      wideBasis={false}
      variant="white"
      noBorder
      className={classNames(styles.segment_button, {
        [styles.segment_button_expanded]: isExpanded,
      })}
      disabled={disabled}
    >
      <span className={styles.segment_button_inner}>
        <Icon name="range_range" size="xs" />
        <span className={styles.segment_button_label}>{children}</span>
        <Icon
          className={classNames({
            [styles.arrow_expanded]: isExpanded,
            [styles.arrow_collapsed]: !isExpanded,
          })}
          name="chevron_small_isolated_s"
          size="xs"
        />
      </span>
    </Button>
  );
}
